
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore } from "@/store";
import { LoadingMutationTypes } from '@/store/modules/loading/mutation-types';
import { getOpportunitiesFromBI } from '@/services/opportunity/opportunityService';
import Card from '@/components/Card.vue';
import Sidebar from '@/components/Sidebar.vue';
import Tabs from '@/components/Tabs.vue';
import PanelList from './PanelList.vue';

export default defineComponent({
  name: 'MyPanel',
  components: {
    Card,
    Sidebar,
    Tabs,
    PanelList
  },
  setup() {
    const store = useStore();
    const isLoading = computed(() => store.getters.loading);
    const isMobile = ref(window.innerWidth <= 768);
    const sidebarOpen = ref(true);
    const reportsOpportunities = ref([]);
    const fundingOpportunities = ref([]);
    const tabs = [
      { title: 'Relatórios', active: true },
      { title: 'Financiamento', active: false },
    ];

    const status = ref('');

    const toggleSidebar = () => {
      sidebarOpen.value = !sidebarOpen.value;
    };

    const userID = ref(0);
    const opportunitiesFromBI = ref<any>([]);
    const fetchOpportunitiesFromBI = async (isReload?: boolean): Promise<void> => {
      try {
        if (!isReload) {
          store.commit(LoadingMutationTypes.SET_LOADING, true);
        }

        const userData = localStorage.getItem("userData");
        if (typeof userData === "string") {
          userID.value = JSON.parse(userData).user_id;
        }

        if (userID.value > 0) {
          const response = await getOpportunitiesFromBI();
          response.forEach((opportunity: any) => {
            if (opportunity.usersallowed.includes(userID.value.toString()) && opportunity.negocio_controle === 1) {
              opportunitiesFromBI.value.push(opportunity);
            }
          });
        }

        opportunitiesFromBI.value.sort((a: any, b: any) => {
          const dateA = new Date(a.created_at).getTime();
          const dateB = new Date(b.created_at).getTime();
          return dateB - dateA;
        });

        reportsOpportunities.value = opportunitiesFromBI.value.filter((opportunity: any) => opportunity.tipo_envio === 1);
        fundingOpportunities.value = opportunitiesFromBI.value.filter((opportunity: any) => opportunity.tipo_envio === 3);
      } catch (error) {
        console.error(error);
      } finally {
        store.commit(LoadingMutationTypes.SET_LOADING, false);
      }
    };

    onMounted(() => {
      fetchOpportunitiesFromBI();

      if (isMobile.value) {
        sidebarOpen.value = false;
      }

      window.addEventListener('resize', () => {
        isMobile.value = window.innerWidth <= 768;
        if (isMobile.value) {
          sidebarOpen.value = false;
        }
      });

      window.addEventListener('keydown', (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 'b') {
          toggleSidebar();
        }
      });
    });

    return {
      isLoading,
      opportunitiesFromBI,
      isMobile,
      toggleSidebar,
      sidebarOpen,
      reportsOpportunities,
      fundingOpportunities,
      tabs,
      status,
    }
  }
})
